import type { IShipmentData } from '@/modules/pmt/interfaces';
import { isEddAvailable } from '@/modules/pmt/utils';
import { EDD } from '@/modules/pmt/components/EDD';
import { TrackingSummaryContainer } from './TrackingSummarySection.styles';

interface ITrackingSummarySectionProps {
  trackingDetails?: IShipmentData;
}

const TrackingSummarySection = ({ trackingDetails }: ITrackingSummarySectionProps) => {
  const isShowEdd = isEddAvailable(trackingDetails);

  if (!isShowEdd) return null;

  return (
    <TrackingSummaryContainer>
      <EDD variant='details' shipmentData={trackingDetails} />
    </TrackingSummaryContainer>
  );
};

export { TrackingSummarySection };
